export default __webpack_public_path__ + "static/media/back-arrow-ami.aa58af29.svg";